export default class Util {

	static encodeApiKey (db_name, api_key) {

		if (db_name === undefined || db_name.length < 8) {
			console.warn('Nem megfelelő adatbázis név paraméter')
			return
		}

		if (api_key === undefined || api_key.length != 9) {
			console.warn('Nem megfelelő API kulcs paraméter')
			return
		}

		// Create the auth code
		let b = Buffer.from(`${db_name.substring(0, 8)}@cstore{${api_key}}`).toString('base64').replace('=', '').split('').reverse()
		let t = b[1]
		b[1] = b[b.length - 1]
		b[b.length - 1] = t
		return b.join('')
	}
}